/**
 * @author 陈韦润
 * @param strKey 要获取的hash的字符串
 */
export default function hashCode(strKey) {
    const MAX_VALUE = 0x7fffffff;
    const MIN_VALUE = -0x80000000;
    const intValue = (num) => {
        if (num > MAX_VALUE || num < MIN_VALUE) {
            return num & 0xffffffff;
        }
        return num;
    };
    let hash = 0;
    if (typeof strKey === 'string') {
        for (let i = 0, l = strKey.length; i < l; i += 1) {
            hash = hash * 31 + strKey.charCodeAt(i);
            hash = intValue(hash);
        }
    }
    return hash;
}
